import styled from '@emotion/styled'

import { baseCarouselStyles } from './__base.styled'

import media from '../../styles/media'
import { carouselProgressBar } from '../../styles/keyframes'

const S = {}

S.Carousel = styled.div`
  ${baseCarouselStyles};

  --arrow-offset: 1.25rem;

  ${media.sm`
    --arrow-offset: 2.5rem;
  `};
  margin-left: auto;
  margin-right: auto;
  display: flex;
  flex-direction: column;
  justify-content: center;
  max-width: 70.625rem;
  box-sizing: border-box;
  height: 100%;

  .slick-slider,
  .slick-list,
  .slick-track,
  .slick-slide,
  .slick-slide > div {
    height: 100%;
  }

  .slick-dots {
    display: absolute;
    list-style: none;
    margin: 0;
    padding: 0;
    bottom: 0;
    width: 100%;
    text-align: center;

    li {
      display: inline-block;
    }
  }

  .slick-active .bar {
    position: relative;
    transform: scaleY(1);

    &::before {
      background-color: #ef4323;
      position: absolute;
      top: 0;
      right: 0;
      bottom: 0;
      left: 0;
      content: '';
      transform: scaleX(0);
      transform-origin: left center;
      animation: ${carouselProgressBar} linear forwards;
      animation-duration: ${({ autoplaySpeed }) =>
        autoplaySpeed ? `${autoplaySpeed}ms` : `3000ms`};
      animation-play-state: ${({ isAutoplayOn }) =>
        isAutoplayOn ? 'running' : 'paused'};
    }
  }
`

export default S
